import {Button, ButtonGroup, showNotification} from 'platform/components';
import {Box, Space} from 'platform/foundation';

import {isArray} from 'ramda-adjunct';

import {useAddUpsellFromCatalogMutation} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {DmsDataGrid, handleApiError} from '@dms/shared';

import {suffixTestId, TestIdProps, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

const PREDEFINED_COLUMNS = ['name'] as const;

interface EditPriceDialogProps extends TestIdProps {
  offerId: string;
  businessCaseId: string;
  offerSaleVehicleId: string;
  onCancel: VoidFunction;
}

export function AddProductFromCatalog(props: EditPriceDialogProps) {
  const navigate = useNavigate();

  const [addUpsellItem] = useAddUpsellFromCatalogMutation();

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = ({
    actionKey,
    rowId,
    getColumnData,
  }) => {
    const productId = isArray(rowId) ? rowId[0] : rowId;
    const name = getColumnData<string>('name')?.value;

    if (actionKey === 'select') {
      addUpsellItem({
        offerId: props.offerId,
        businessCaseId: props.businessCaseId,
        offerSaleVehicleId: props.offerSaleVehicleId,
        body: {productId},
      })
        .unwrap()
        .then(() =>
          showNotification.success(i18n.t('entity.productCatalog.notifications.itemAdded', {name}))
        )
        .catch(handleApiError);
    }
  };

  return (
    <>
      <Box height={200}>
        <DmsDataGrid
          gridCode="select_from_product_catalog"
          actionCallback={actionCallback}
          predefinedColumns={PREDEFINED_COLUMNS}
          emptyState={{
            action: {
              onClick: () => navigate(settingsRoutes.productCatalog),
              title: i18n.t('entity.productCatalog.actions.addProduct'),
            },
          }}
          data-testid={suffixTestId('grid', props)}
        />
      </Box>

      <Space vertical={4} />

      <ButtonGroup align="right">
        <Button
          variant="secondary"
          onClick={props.onCancel}
          title={i18n.t('general.actions.cancel')}
          data-testid={suffixTestId('cancel', props)}
        />
      </ButtonGroup>
    </>
  );
}
